'use client';

import ClientPricingPage from "@/app/quiz/pre-checkout/ClientPricingPage";
import { useStripeContext } from "@/context/StripeContextProvider";
import { useEffect } from "react";

export const PreCheckoutImproved = ({ userEmail, onEmailChange }) => {
	const { setStripeData } = useStripeContext();

	useEffect(() => {
		setStripeData({ userEmail });
	}, [userEmail]);

	return (
		<ClientPricingPage userEmail={userEmail} onEmailChange={onEmailChange} />
	);
};
